import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import { AppDispatch } from '../store'
import { fetchPlacementList } from '../store/placementsSlice'
import { RootState } from '../store/rootReducer'
import Pagination from '../components/Pagination'

const Placements = (): React.ReactElement | null => {
  const { t } = useTranslation(['placements', 'common'])
  const dispatch = useDispatch<AppDispatch>()
  const { placements, loading, error, totalPages, currentLimit, currentPage, totalCount } = useSelector(
    (state: RootState) => state.placements
  )
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)

  useEffect(() => {
    dispatch(
      fetchPlacementList({
        page,
        limit,
      })
    )
  }, [dispatch, page, limit])

  if (loading === 'pending') {
    // TODO: Loader...
    return null
  }

  if (error) {
    // TODO: Upp kom óvænt villa...
    return null
  }

  return (
    <Card>
      <Card.Body>
        <h4>{t('skraningar')}</h4>
        {placements == null || placements.length === 0 ? (
          <div className="pb-3 pt-3">
            <i>{t('engarSkraningar')}.</i>
          </div>
        ) : (
          <div className="mt-3">
            <table className="table">
              <thead>
                <tr className="bg-gray-200 small">
                  <th>{t('nafn')}</th>
                  <th>
                    <div className="d-none d-md-block">{t('kennitala')}</div>
                  </th>
                  <th>
                    <div className="d-none d-md-block">{t('timabil')}</div>
                  </th>
                  <th>{t('starfstimabil')}</th>
                  <th>{t('vinnustadur')}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {placements?.map((placement) => (
                  <tr key={placement.id}>
                    <td>{placement.person.name}</td>
                    <td>
                      <div className="d-none d-md-block">{placement.person.ssn}</div>
                    </td>
                    <td>
                      <div className="d-none d-md-block">{placement.placement_group.period.name}</div>
                    </td>
                    <td>
                      {placement.placement_group.period_part ? (
                        <span>
                          {dayjs(placement.placement_group.period_part.date_from).format('DD.MM.YYYY')} -{' '}
                          {dayjs(placement.placement_group.period_part.date_to).format('DD.MM.YYYY')}
                        </span>
                      ) : (
                        <span>
                          {dayjs(placement.placement_group.period.date_from).format('DD.MM.YYYY')} -{' '}
                          {dayjs(placement.placement_group.period.date_to).format('DD.MM.YYYY')}
                        </span>
                      )}
                    </td>
                    <td>
                      <div className="d-inline-block">{placement.placement_group.workplace.name}</div>
                      <div className="d-inline-block">
                        <span className="d-none d-md-block">- {placement.placement_group.name}</span>
                      </div>
                      {placement.is_moved && (
                        <div className="small text-muted">
                          {t('faerdur')}
                          {placement.date_to && (
                            <>
                              {' '}
                              {t('common:fra')} {dayjs(placement.date_to).format('DD.MM.YYYY')}
                            </>
                          )}
                          .
                        </div>
                      )}
                      {placement.is_removed && (
                        <div className="small text-muted">
                          {t('fjarlaegdur')}
                          {placement.date_to && (
                            <>
                              {' '}
                              {t('common:fra')} {dayjs(placement.date_to).format('DD.MM.YYYY')}
                            </>
                          )}
                          .
                        </div>
                      )}
                    </td>

                    <td>
                      <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-view`}>{t('skoda')}</Tooltip>}>
                        <Link
                          className="btn btn-secondary float-right"
                          style={{ color: '#fff' }}
                          to={`/skraning/${placement.id}`}
                        >
                          <div className="d-inline-block">
                            <FontAwesomeIcon icon={faSearch} />
                          </div>
                        </Link>
                      </OverlayTrigger>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {totalPages > 1 && (
              <Pagination
                currentLimit={currentLimit}
                currentPage={currentPage}
                currentLength={placements.length}
                totalCount={totalCount}
                totalPages={totalPages}
                onPageChange={setPage}
                onLimitChange={setLimit}
              />
            )}
          </div>
        )}
      </Card.Body>
    </Card>
  )
}

export default Placements
